import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import {AuthComponent} from './theme/layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/auth/signin',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'cotizador',
        loadChildren: () => import('./module/cotizador/cotizador.module').then(module => module.CotizadorModule)
      },
      {
        path: 'usuario',
        loadChildren: () => import('./module/usuario/usuario.module').then(module => module.UsuarioModule)
      },
      {
        path: 'layout',
        loadChildren: () => import('./demo/pages/layout/layout.module').then(module => module.LayoutModule)
      },
      {
        path: 'basic',
        loadChildren: () => import('./demo/ui-elements/ui-basic/ui-basic.module').then(module => module.UiBasicModule)
      },
      {
        path: 'forms',
        loadChildren: () => import('./demo/pages/form-elements/form-elements.module').then(module => module.FormElementsModule)
      },
      {
        path: 'tbl-bootstrap',
        loadChildren: () => import('./demo/pages/tables/tbl-bootstrap/tbl-bootstrap.module').then(module => module.TblBootstrapModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./demo/pages/core-chart/core-chart.module').then(module => module.CoreChartModule)
      },
      {
        path: 'maps',
        loadChildren: () => import('./demo/pages/core-maps/core-maps.module').then(module => module.CoreMapsModule)
      },
      {
        path: 'sample-page',
        loadChildren: () => import('./demo/pages/sample-page/sample-page.module').then(module => module.SamplePageModule)
      },
      {
        path: 'dash',
        loadChildren: () => import('./module/dash/dash.module').then(module => module.DashModule)
      },
      {
        path: 'reportes',
        loadChildren: () => import('./module/reportes/reportes.module').then(module => module.ReportesModule)
      },
      {
        path: 'polizas',
        loadChildren: () => import('./module/poliza/poliza.module').then(module => module.PolizaModule)
      },
      {
        path: 'licitacion',
        loadChildren: () => import('./module/licitaciones/licitaciones.module').then(module => module.LicitacionesModule)
      },
      {
        path: 'taller',
        loadChildren: () => import('./module/taller/taller.module').then(module => module.TallerModule)
       },
       {
        path: 'tutoriales',
        loadChildren: () => import('./module/tutorial/tutorial.module').then(module => module.TutorialModule)
       },
       {
        path: 'exportar',
        loadChildren: () => import('./module/exportarDatos/exportarDatos.module').then(module => module.ExportarDatosModule)
       },
       {
        path: 'asegurados',
        loadChildren: () => import('./module/asegurados/asegurado.module').then(module => module.AseguradoModule)
       },
       {
        path: 'agentes',
        loadChildren: () => import('./module/agentes/agentes.module').then(module => module.AgentesModule)
       },
       {
        path: 'transporte',
        loadChildren: () => import('./module/transporte/transporte.module').then(module => module.TransporteModule)
       },
       {
        path: 'difusion',
        loadChildren: () => import('./module/difusion/difusion.module').then(module => module.DifusionModule)
       },

    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then(module => module.AuthenticationModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
